import { toggleableStateKeptInSessionStorageFactory } from './toggleable-state-kept-in-session-storage-factory';

const LOCAL_BACKEND_IS_ACTIVE_STORAGE_KEY = 'local-backend-is-active';

export class LocalBackendState extends toggleableStateKeptInSessionStorageFactory(LOCAL_BACKEND_IS_ACTIVE_STORAGE_KEY) {
}
